import type { JsonLogicTree } from "react-awesome-query-builder";

export const jsonLogicDefault: JsonLogicTree = {
  errors: [],
  logic: {},
  data: {}
};
